'use strict';

class PREVIEW {
   constructor($http, $filter) {
    this.$http = $http;
    this.$filter = $filter;
  }

  $onInit() {
    this.previewVisible = false;
    this.preference = this.preference || false;
    this.fetchData = this.fetchData || false;
    this.types = {
      invoice: 'invoices',
      creditNote: 'invoices/credit-notes',
      dunning: 'dunnings',
      offer: 'offer',
      orderConfirmation: 'order-confirmation'
    };
  }

  actions($event) {
    if (this.previewVisible) {
      if ($event.keyCode === 27) {
        this.closePreview();
      }
    }
  }

  closePreview() {
    let modal = document.querySelector('.preview-modal');
    modal.style.display = 'none';
    this.previewVisible = false;
  }

  preview() {
    if (this.fetchData) {
      this.data = this.getData();
    }

    if (this.type && this.type in this.types) {
      let t = this.types[this.type];
      let url = `/${t}/drafts/preview`;

      if (this.preference) {
        url = url + '?preference=true';
      }

      if (this.data.items && this.data.items.length) {
        this.data.items.forEach((item) => {
          item.unitPrice = this.$filter('defaultValue')(this.$filter('numberify')(item.unitPrice), null);
          item.quantity = this.$filter('defaultValue')(this.$filter('numberify')(item.quantity), null);
          return item;
        }, this);
      }

      this.$http.post(url, this.data)
        .then((resp) => {
          let modal = document.querySelector('.preview-modal');
          modal.style.display = 'block';

          $('#modalContent').html('<img src=\'data:image/jpg;base64,' + resp.data + '\' alt=\'\' class=\'document-preview\' />');
          this.previewVisible = true;
        })
        .catch((err) => {
          // // console.log(err);
        });
    }
  }
}

PREVIEW.$inject = ['$http', '$filter'];

// fetchData parameter is requred to use getData method to fetch data
const preview = {
  bindings: {
    data: '<',
    type: '<',
    preference: '<',
    fetchData: '<',
    getData: '&'
  },
  controller: PREVIEW,
  template:
    `
    <span ng-keydown="$ctrl.actions($event)" tabindex="0">
    <button class="button secondary" ng-click="$ctrl.preview()">Forhåndsvisning</button>

    <div class="preview-modal" style="overflow:scroll; z-index: 100;">
      <div class="preview-modal-content"style=" width:70%">
        <span class="close-btn" ng-click="$ctrl.closePreview()">
          <i class="fa fa-times fa-lg" ng-click="$ctrl.closePreview()"></i>
        </span>
        <div id="modalContent"></div>
      </div>
    </div>
    <img ng-show="$ctrl.image" ng-src="data:image/jpg;base64,{{ $ctrl.image }}" alt="" class="document-preview" />
    </span>
  `
};

angular
  .module('SendRegning')
  .component('preview', preview);
